import React, { Suspense } from 'react';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import PositionsTableSkeleton from 'components/data-containers/PositionsTable/SkeletonLoader';

import { CompareModes } from 'context/entityContext';
import { TopicFilterNames } from 'components/TopicFilters/shared';

const CurrentPositionsTable = React.lazy(
  () =>
    import(
      'components/data-containers/PositionsTable/CurrentPositionsTable'
    ) as any
);

const PeakPositionsTable = React.lazy(
  () =>
    import(
      'components/data-containers/PositionsTable/PeakPositionsTable'
    ) as any
);

interface IRadioChartsProps {
  compareMode?: CompareModes;
}

const allowedFilters: TopicFilterNames[] = ['country'];
const chartType = 'airplay';

const RadioCharts: React.FC<IRadioChartsProps> = (props) => {
  const { compareMode } = props;
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>
          Unfortunately there are no other components available in compare mode
          on this topic for projects.
        </Message>
      </Layout.MaxWidth>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Track Chart Positions"
            productType="track"
            variation="currentPosition"
            short
          />
        }
      >
        <CurrentPositionsTable
          productType="track"
          title="Track Chart Positions"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          chartType={chartType}
          short
        />
      </Suspense>

      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Track Peak Positions by Country"
            productType="track"
            variation="peakPosition"
          />
        }
      >
        <PeakPositionsTable
          title="Track Peak Positions by Country"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          productType="track"
          chartType={chartType}
        />
      </Suspense>

      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Release Chart Position"
            productType="album"
            variation="currentPosition"
            short
          />
        }
      >
        <CurrentPositionsTable
          title="Release Chart Position"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          productType="album"
          chartType={chartType}
          short
          hasSplitedExports
        />
      </Suspense>

      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Release Peak Positions by Country"
            productType="album"
            variation="currentPosition"
          />
        }
      >
        <PeakPositionsTable
          title="Release Peak Positions by Country"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          productType="album"
          chartType={chartType}
        />
      </Suspense>
    </div>
  );
};

export default RadioCharts;
